export class ChangePasswordRequest {
    oldPassword: string = '';
    newPassword: string = '';
    confirmPassword: string = '';
}

export class UpdatePasswordRequest {
  public userId: number = 0;
  public oldPassword: string = '';
  public newPassword: string = '';
  public confirmPassword: string = '';
  public doNotTriggerEvent : boolean = false;
  
}
